import { useTabContext } from "@mui/lab/TabContext";
import { TabPanelProps } from "@mui/lab/TabPanel";


const PersistentTabPanel = (props: TabPanelProps) => {

    const context = useTabContext();

    if (context == null)
        throw new Error('No TabContext available');

    const tabId = context.value;
    const panelId = [context.idPrefix, 'P', props.value].join('-');
    const tabButtonId = [context.idPrefix, 'T', props.value].join('-');

    return (
        <div
            id={panelId}
            className={['MuiTabPanel-root', props.className].join(' ')}
            style={props.style}
            hidden={props.value !== tabId}
            aria-labelledby={tabButtonId}
        >
            {props.children}
        </div>
    );

};

export default PersistentTabPanel;